import { Base2Presenter } from "core/presenter";

export default class OptionalPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      filter: {}
    };
  }

  getFilter(filter) {
    return [
      { connector: "AND", field: "name", operation: "LIKE", value: filter }
    ];
  }

  onCreate() {
    this.navigateTo("app.registration.optional_group.create");
  }

  setLoading = async value => {
    this.enqueue({ loading: value });
  };

  handleFilterChange = filter => {
    this.enqueue({ filter });
  };
}



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/presenter.js